(function (window, document) {
  'use strict';

  var DATA = window.NATUCOPOS_PRICING_V21;
  var CORE = window.NatucoposPricingCoreV21;
  var root = document.documentElement;
  var scheduled = false;
  var observer = null;
  var diagnostics = {
    version: '2.1.0-clean-qa',
    integrity: null,
    scans: 0,
    cardsSafe: 0,
    cardsReview: 0,
    productSafe: 0,
    productReview: 0,
    cartSafe: 0,
    cartReview: 0,
    checkoutBlocked: false,
    errors: [],
  };
  window.NGI_V21_DIAGNOSTICS = diagnostics;
  var cartProductCache = Object.create(null);

  function region() {
    if (window.NatucoposRegion && typeof window.NatucoposRegion.get === 'function') {
      return window.NatucoposRegion.get() === 'GO' ? 'GO' : 'BR';
    }
    return root.getAttribute('data-nc-region') === 'GO' ? 'GO' : 'BR';
  }

  function money(cents) {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2,
    }).format((Number(cents) || 0) / 100);
  }

  function unitMoney(perThousandCents) {
    return 'R$ ' + ((Number(perThousandCents) || 0) / 100000).toLocaleString('pt-BR', {
      minimumFractionDigits: 4, maximumFractionDigits: 4,
    });
  }

  function quantity(value) {
    return Math.max(0, Number(value) || 0).toLocaleString('pt-BR');
  }

  function commercialTerms(reg) {
    if (reg === 'GO') {
      return 'Até 6x sem juros no cartão · Frete grátis a partir de R$ 500 em Goiás · 3% no Pix à vista';
    }
    return 'Até 6x sem juros no cartão · Frete grátis em pedidos a partir de R$ 2.000 · 3% no Pix à vista';
  }

  function priceBookName(reg) {
    return reg === 'GO' ? 'Tabela Goiás' : 'Tabela Brasil';
  }


  function regionState() {
    if (window.NatucoposRegion && typeof window.NatucoposRegion.current === 'function') {
      return window.NatucoposRegion.current();
    }
    return {
      choice: root.getAttribute('data-nc-region-choice') === 'saved',
      region: region(),
      verified: region() === 'GO',
      uf: region() === 'GO' ? 'GO' : '',
      cep: '',
      cepMasked: '',
      city: '',
    };
  }

  function createRegionControl() {
    var existing = document.querySelector('[data-nc-v21-region-toggle]');
    if (existing) return existing;

    var list = document.querySelector('.header-top-meta .header-control') || document.querySelector('.header-control');
    var wrapper = document.createElement(list ? 'li' : 'div');
    wrapper.className = 'nc-v21-region-switch-item' + (list ? '' : ' is-floating');
    wrapper.innerHTML = [
      '<button type="button" class="nc-v21-region-toggle" data-nc-v21-region-toggle aria-label="Alterar região dos preços">',
      '<span class="nc-v21-region-toggle__dot" aria-hidden="true"></span>',
      '<span class="nc-v21-region-toggle__label">Região:</span>',
      '<strong data-nc-v21-region-value>Demais</strong>',
      '</button>',
    ].join('');

    if (list) {
      var cart = list.querySelector('.box-minicart') || list.querySelector('[class*="minicart"]');
      if (cart) list.insertBefore(wrapper, cart);
      else list.appendChild(wrapper);
    } else if (document.body) {
      document.body.appendChild(wrapper);
    }

    var button = wrapper.querySelector('[data-nc-v21-region-toggle]');
    if (button) button.addEventListener('click', function () { openRegionModal(true); });
    return button;
  }

  function syncRegionControl() {
    var state = regionState();
    var button = createRegionControl();
    if (!button) return;
    var isGo = state.region === 'GO' && state.verified === true && state.uf === 'GO';
    button.classList.toggle('is-go', isGo);
    button.setAttribute('aria-pressed', isGo ? 'true' : 'false');
    var value = button.querySelector('[data-nc-v21-region-value]');
    if (value) value.textContent = isGo ? 'Goiás' : 'Demais';
    var location = isGo && state.city ? ' · ' + state.city : '';
    var cep = isGo && state.cepMasked ? ' · CEP ' + state.cepMasked : '';
    button.title = isGo
      ? 'Tabela Goiás ativa' + location + cep + '. Clique para alterar.'
      : 'Tabela Brasil ativa. Clique para alterar.';
  }

  function closeRegionModal() {
    var modal = document.querySelector('[data-nc-v21-region-modal]');
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('nc-v21-region-modal-open');
  }

  function createRegionModal() {
    var existing = document.querySelector('[data-nc-v21-region-modal]');
    if (existing) return existing;

    var modal = document.createElement('div');
    modal.className = 'nc-v21-region-modal';
    modal.setAttribute('data-nc-v21-region-modal', '');
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML = [
      '<div class="nc-v21-region-modal__backdrop" data-nc-v21-region-close></div>',
      '<div class="nc-v21-region-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="nc-v21-region-title">',
      '<button type="button" class="nc-v21-region-modal__close" data-nc-v21-region-close aria-label="Fechar">×</button>',
      '<span class="nc-v21-region-modal__eyebrow">Preços por região</span>',
      '<h2 id="nc-v21-region-title">Onde será a entrega?</h2>',
      '<p class="nc-v21-region-modal__lead">Em Goiás, a Natucopos possui uma tabela regional com preços e condições próprias. Escolha a região de entrega para ver os preços e as condições disponíveis.</p>',
      '<div class="nc-v21-region-choices">',
      '<button type="button" class="nc-v21-region-choice is-go" data-nc-v21-region-go><strong>Goiás</strong><span>Informe um CEP de entrega em GO para usar a Tabela Goiás.</span></button>',
      '<button type="button" class="nc-v21-region-choice" data-nc-v21-region-br><strong>Demais regiões</strong><span>Usar a Tabela Brasil e as condições nacionais.</span></button>',
      '</div>',
      '<form class="nc-v21-region-cep" data-nc-v21-region-cep>',
      '<label for="nc-v21-region-cep-input">CEP de entrega em Goiás</label>',
      '<div><input id="nc-v21-region-cep-input" name="cep" inputmode="numeric" autocomplete="postal-code" maxlength="9" placeholder="00000-000"><button type="submit">Usar preços de Goiás</button></div>',
      '<p data-nc-v21-region-feedback aria-live="polite"></p>',
      '</form>',
      '<div class="nc-v21-region-modal__conditions"><span>Até 6x sem juros no cartão</span><span>3% no Pix à vista</span><span>GO: frete grátis a partir de R$ 500</span></div>',
      '<p class="nc-v21-region-modal__foot">Depois da primeira escolha, não perguntaremos novamente neste navegador. A região pode ser alterada no cabeçalho.</p>',
      '</div>',
    ].join('');
    document.body.appendChild(modal);

    var goChoice = modal.querySelector('[data-nc-v21-region-go]');
    var brChoice = modal.querySelector('[data-nc-v21-region-br]');
    var form = modal.querySelector('[data-nc-v21-region-cep]');
    var input = form.querySelector('input[name="cep"]');
    var feedback = modal.querySelector('[data-nc-v21-region-feedback]');

    goChoice.addEventListener('click', function () {
      form.classList.add('is-open');
      feedback.textContent = '';
      window.setTimeout(function () { input.focus(); }, 20);
    });

    brChoice.addEventListener('click', function () {
      if (window.NatucoposRegion && typeof window.NatucoposRegion.selectBR === 'function') {
        window.NatucoposRegion.selectBR();
      }
      closeRegionModal();
      syncRegionControl();
    });

    input.addEventListener('input', function () {
      var digits = String(input.value || '').replace(/\D/g, '').slice(0, 8);
      input.value = digits.length > 5 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits;
    });

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      var submit = form.querySelector('button[type="submit"]');
      feedback.textContent = 'Validando CEP…';
      submit.disabled = true;
      try {
        if (!window.NatucoposRegion || typeof window.NatucoposRegion.resolveCep !== 'function') {
          throw new Error('Validador regional indisponível. A Tabela Brasil foi preservada.');
        }
        await window.NatucoposRegion.resolveCep(input.value);
        feedback.textContent = '';
        closeRegionModal();
        syncRegionControl();
      } catch (error) {
        feedback.textContent = error && error.message ? error.message : 'Não foi possível validar o CEP.';
      } finally {
        submit.disabled = false;
      }
    });

    Array.prototype.slice.call(modal.querySelectorAll('[data-nc-v21-region-close]')).forEach(function (button) {
      button.addEventListener('click', function () {
        if (window.NatucoposRegion && window.NatucoposRegion.hasChoice()) closeRegionModal();
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && window.NatucoposRegion && window.NatucoposRegion.hasChoice()) closeRegionModal();
    });
    return modal;
  }

  function openRegionModal(editMode) {
    var modal = createRegionModal();
    var hasChoice = !!(window.NatucoposRegion && window.NatucoposRegion.hasChoice());
    var state = regionState();
    var close = modal.querySelector('.nc-v21-region-modal__close');
    var form = modal.querySelector('[data-nc-v21-region-cep]');
    var input = form.querySelector('input[name="cep"]');
    var feedback = modal.querySelector('[data-nc-v21-region-feedback]');

    if (close) close.hidden = !hasChoice && !editMode;
    form.classList.remove('is-open');
    feedback.textContent = '';
    if (state.region === 'GO' && state.cep) input.value = state.cep.slice(0, 5) + '-' + state.cep.slice(5);
    else input.value = '';

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('nc-v21-region-modal-open');
  }

  function initRegionUi() {
    createRegionControl();
    createRegionModal();
    syncRegionControl();
    if (window.NatucoposRegion && !window.NatucoposRegion.hasChoice()) {
      window.setTimeout(function () { openRegionModal(false); }, 0);
    }
  }

  function productScript(container) {
    return container && container.querySelector ? container.querySelector('.data-json-product') : null;
  }

  function parseProduct(container) {
    var script = productScript(container);
    if (!script) return null;
    try {
      var json = JSON.parse(script.textContent || '{}');
      var pricing = json.pricing || {};
      var variants = Array.isArray(json.variants) ? json.variants : [];
      var defaultVariantId = String(json.default_variant_id || '');
      var variant = variants.filter(function (item) { return String(item.id) === defaultVariantId; })[0] || variants[0] || {};
      var normalized = CORE.normalizeProductPricing({
        active: pricing.active !== undefined ? pricing.active : pricing.ativo,
        idProduct: pricing.idProduct || pricing.id_produto || variant.sku || '',
        p1000: pricing.p1000 !== undefined ? pricing.p1000 : pricing.preco_1000,
        p2000: pricing.p2000 !== undefined ? pricing.p2000 : pricing.preco_2000,
        p5000: pricing.p5000 !== undefined ? pricing.p5000 : pricing.preco_5000,
        p10000: pricing.p10000 !== undefined ? pricing.p10000 : pricing.preco_10000,
      });
      return {
        json: json,
        pricing: normalized,
        title: String(json.title || ''),
        handle: String(json.handle || ''),
        variantId: String(variant.id || ''),
        container: container,
      };
    } catch (error) {
      diagnostics.errors.push('INVALID_PRODUCT_JSON');
      console.error('[Natucopos V2.1] JSON de produto inválido.', error);
      return null;
    }
  }

  function resolveProduct(product) {
    return product ? CORE.resolveProduct(DATA, product.pricing) : {
      status: 'UNMAPPED', reason: 'PRODUCT_JSON_MISSING', safe: false, row: null,
    };
  }

  function removeNode(node) {
    if (node && node.parentNode) node.parentNode.removeChild(node);
  }

  function removeAll(container, selector) {
    if (!container || !container.querySelectorAll) return;
    Array.prototype.slice.call(container.querySelectorAll(selector)).forEach(removeNode);
  }

  function legacyVisible(node) {
    if (node) node.classList.remove('nc-v21-legacy-hidden');
  }

  function legacyHidden(node) {
    if (node) node.classList.add('nc-v21-legacy-hidden');
  }

  function consultMessage(container, reason) {
    var existing = container.querySelector('.nc-v21-consult');
    if (!reason || (region() !== 'GO' && reason !== 'SOURCE_BLOCKED')) {
      removeNode(existing);
      return;
    }
    if (!existing) {
      existing = document.createElement('div');
      existing.className = 'nc-v21-consult';
      var price = container.querySelector('.product-collection__price,.product-price,.nc-card-commerce-pod');
      if (price) price.insertAdjacentElement('afterend', existing);
      else container.appendChild(existing);
    }
    if (reason === 'SOURCE_BLOCKED') {
      Array.prototype.slice.call(container.querySelectorAll('.product-collection__price,.product-price,.nc-card-commerce-pod,.cart_meta_price,.cart_meta_prices,.js_tt_price_it,.nc-v21-table,.nc-v21-builder')).forEach(legacyHidden);
      var homeHost = homePodHost(container);
      if (homeHost) Array.prototype.slice.call(homeHost.querySelectorAll('.nc-card-commerce-pod')).forEach(legacyHidden);
    }
    existing.textContent = reason === 'SOURCE_BLOCKED'
      ? 'Preço a consultar. Solicite orçamento pelo WhatsApp.'
      : 'Para entrega em Goiás, consulte o preço deste produto pelo WhatsApp.';
    if (reason) {
      var contact = document.createElement('a');
      contact.textContent = ' Consultar no WhatsApp';
      var heading = container.querySelector('h1,h2,h3,.product-name');
      contact.href = 'https://wa.me/5564999480738?text=' + encodeURIComponent('Olá! Quero consultar o preço de ' + (heading ? heading.textContent.trim() : 'um produto') + '. Região de entrega: ' + priceBookName(region()) + '.');
      contact.target = '_blank'; contact.rel = 'noopener';
      existing.appendChild(contact);
    }

  }

  function homePodHost(container) {
    return container.closest('.product-item,.ui-item') || container;
  }

  function renderHomeCard(container, product, resolution, reg) {
    var host = homePodHost(container);
    var legacyPod = host.querySelector('.nc-card-commerce-pod:not(.nc-v21-home-pod)');
    var existing = host.querySelector('.nc-v21-home-pod');
    if (!resolution.safe || !resolution.row) {
      host.removeAttribute('data-nc-v21-resolved');
      legacyVisible(legacyPod);
      removeNode(existing);
      consultMessage(container, resolution.reason);
      diagnostics.cardsReview += 1;
      return;
    }
    consultMessage(container, null);
    host.setAttribute('data-nc-v21-resolved', 'true');
    legacyHidden(legacyPod);
    var price = CORE.priceFor(resolution.row, reg, 10000);
    if (!price) {
      host.removeAttribute('data-nc-v21-resolved');
      legacyVisible(legacyPod);
      removeNode(existing);
      diagnostics.cardsReview += 1;
      return;
    }
    if (!existing) {
      existing = document.createElement('div');
      existing.className = 'nc-v21-home-pod';
      existing.innerHTML = [
        '<div class="nc-v21-home-price" data-nc-v21-price></div>',
        '<div class="nc-v21-home-meta">por milheiro · faixa de 10.000 un.</div>',
        '<div class="nc-v21-home-terms" data-nc-v21-terms></div>',
        '<a class="nc-v21-home-link" data-nc-v21-link><span>Ver mais</span></a>',
      ].join('');
      if (legacyPod) legacyPod.insertAdjacentElement('afterend', existing);
      else {
        var originalPrice = container.querySelector('.product-collection__price,.price,.product-price');
        if (originalPrice) originalPrice.insertAdjacentElement('afterend', existing);
        else container.appendChild(existing);
      }
    }
    existing.querySelector('[data-nc-v21-price]').textContent = money(price.perThousandCents);
    existing.querySelector('[data-nc-v21-terms]').textContent = commercialTerms(reg);
    var link = existing.querySelector('[data-nc-v21-link]');
    link.href = product.handle ? '/products/' + product.handle : '#';
    link.setAttribute('aria-label', 'Ver mais sobre ' + product.title);
    existing.setAttribute('data-nc-v21-row', resolution.row.id);
    existing.setAttribute('data-nc-v21-region', reg);
    diagnostics.cardsSafe += 1;
  }

  function renderGridCard(container, product, resolution, reg) {
    var legacyPrice = container.querySelector('.product-collection__price');
    var existing = container.querySelector('.nc-v21-grid-price');
    if (!resolution.safe || !resolution.row) {
      container.removeAttribute('data-nc-v21-resolved');
      legacyVisible(legacyPrice);
      removeNode(existing);
      consultMessage(container, resolution.reason);
      diagnostics.cardsReview += 1;
      return;
    }
    consultMessage(container, null);
    container.setAttribute('data-nc-v21-resolved', 'true');
    var price = CORE.priceFor(resolution.row, reg, 1000);
    if (!price) {
      container.removeAttribute('data-nc-v21-resolved');
      legacyVisible(legacyPrice);
      removeNode(existing);
      diagnostics.cardsReview += 1;
      return;
    }
    legacyHidden(legacyPrice);
    if (!existing) {
      existing = document.createElement('div');
      existing.className = 'nc-v21-grid-price';
      existing.innerHTML = [
        '<div class="nc-v21-grid-price__value" data-nc-v21-price></div>',
        '<div class="nc-v21-grid-price__meta">por 1.000 unidades</div>',
        '<div class="nc-v21-grid-price__terms" data-nc-v21-terms></div>',
      ].join('');
      if (legacyPrice) legacyPrice.insertAdjacentElement('afterend', existing);
      else container.appendChild(existing);
    }
    existing.querySelector('[data-nc-v21-price]').textContent = money(price.totalCents);
    existing.querySelector('[data-nc-v21-terms]').textContent = commercialTerms(reg);
    existing.setAttribute('data-nc-v21-row', resolution.row.id);
    existing.setAttribute('data-nc-v21-region', reg);
    diagnostics.cardsSafe += 1;
  }

  function renderCard(container) {
    var product = parseProduct(container);
    if (!product) return;
    var resolution = resolveProduct(product);
    var reg = region();
    var isHome = !!container.closest('.products-list-countdown') || !!homePodHost(container).querySelector('.nc-card-commerce-pod');
    if (isHome) renderHomeCard(container, product, resolution, reg);
    else renderGridCard(container, product, resolution, reg);
  }

  function termsNode(reg) {
    var node = document.createElement('div');
    node.className = 'nc-v21-terms';
    node.innerHTML = '<strong>' + priceBookName(reg) + '</strong>' + commercialTerms(reg);
    return node;
  }

  function renderMainPrice(main, product, resolution, reg) {
    var legacy = main.querySelector('.product-price');
    var existing = main.querySelector('.nc-v21-main-price');
    var existingTerms = main.querySelector('.nc-v21-terms');
    if (!resolution.safe || !resolution.row) {
      main.removeAttribute('data-nc-v21-resolved');
      legacyVisible(legacy);
      removeNode(existing);
      removeNode(existingTerms);
      consultMessage(main, resolution.reason);
      return false;
    }
    consultMessage(main, null);
    main.setAttribute('data-nc-v21-resolved', 'true');
    var price = CORE.priceFor(resolution.row, reg, 1000);
    if (!price) {
      main.removeAttribute('data-nc-v21-resolved');
      legacyVisible(legacy);
      removeNode(existing);
      removeNode(existingTerms);
      return false;
    }
    legacyHidden(legacy);
    if (!existing) {
      existing = document.createElement('div');
      existing.className = 'nc-v21-main-price';
      existing.innerHTML = '<div class="nc-v21-main-price__value" data-nc-v21-main-value></div><div class="nc-v21-main-price__meta">1.000 unidades · uma arte</div>';
      if (legacy) legacy.insertAdjacentElement('afterend', existing);
      else main.prepend(existing);
    }
    existing.querySelector('[data-nc-v21-main-value]').textContent = money(price.totalCents);
    existing.setAttribute('data-nc-v21-row', resolution.row.id);
    existing.setAttribute('data-nc-v21-region', reg);
    if (!existingTerms) {
      existingTerms = termsNode(reg);
      existing.insertAdjacentElement('afterend', existingTerms);
    } else {
      existingTerms.innerHTML = '<strong>' + priceBookName(reg) + '</strong>' + commercialTerms(reg);
    }
    return true;
  }

  function renderPriceTable(main, resolution, reg) {
    var legacy = main.querySelector('.natc-price-box');
    var existing = main.querySelector('.nc-v21-table');
    if (!resolution.safe || !resolution.row) {
      legacyVisible(legacy);
      removeNode(existing);
      return;
    }
    legacyHidden(legacy);
    if (!existing) {
      existing = document.createElement('section');
      existing.className = 'nc-v21-table';
      if (legacy) legacy.insertAdjacentElement('afterend', existing);
      else main.appendChild(existing);
    }
    var base = CORE.priceFor(resolution.row, reg, 1000);
    var cards = CORE.TIERS.map(function (tier) {
      var price = CORE.priceFor(resolution.row, reg, tier);
      if (!price) return '';
      var normalTotal = base.perThousandCents * tier / 1000;
      var savings = Math.max(0, Math.round(normalTotal - price.totalCents));
      return [
        '<article class="nc-v21-tier', tier === 10000 ? ' is-best' : '', '" data-nc-v21-tier="', tier, '">',
        '<div class="nc-v21-tier__qty">', quantity(tier), ' unidades</div>',
        '<div class="nc-v21-tier__total">', money(price.totalCents), '</div>',
        '<div class="nc-v21-tier__mil">', money(price.perThousandCents), ' por milheiro</div>',
        '<div class="nc-v21-tier__unit">', unitMoney(price.perThousandCents), ' por unidade</div>',
        '<div class="nc-v21-tier__save">', savings ? 'Economia de ' + money(savings) + ' vs. faixa de 1.000' : '', '</div>',
        '</article>',
      ].join('');
    }).join('');
    existing.innerHTML = [
      '<div class="nc-v21-table__head"><div><h3>Tabela por quantidade</h3><p>O mesmo livro de preços governa produto, orçamento e região.</p></div><span class="nc-v21-table__region">', priceBookName(reg), '</span></div>',
      '<div class="nc-v21-table__grid">', cards, '</div>',
    ].join('');
    existing.setAttribute('data-nc-v21-row', resolution.row.id);
    existing.setAttribute('data-nc-v21-region', reg);
  }

  function quantityOptions(selected) {
    var html = '';
    for (var value = 1000; value <= 10000; value += 1000) {
      html += '<option value="' + value + '"' + (value === selected ? ' selected' : '') + '>' + quantity(value) + ' un.</option>';
    }
    return html;
  }

  function accessoryOptions(product, selectedRowId) {
    var options = CORE.safeAccessories(DATA, product.pricing.sku);
    var html = '<option value="">Sem tampa ou acessório</option>';
    options.forEach(function (option) {
      html += '<option value="' + option.rowId + '" data-minimum="' + option.minimum + '" data-step="' + option.step + '"' + (selectedRowId === option.rowId ? ' selected' : '') + '>' + option.label + '</option>';
    });
    return { html: html, count: options.length };
  }

  function builderMarkup(product, reg) {
    var accessory = accessoryOptions(product, null);
    var rows = '';
    for (var i = 1; i <= 5; i += 1) {
      rows += [
        '<div class="nc-v21-art" data-nc-v21-art="', i, '"', i > 1 ? ' hidden' : '', '>',
        '<div class="nc-v21-art__name">Arte ', i, '</div>',
        '<label>Quantidade do produto<select data-nc-v21-quantity>', quantityOptions(1000), '</select></label>',
        '<label>Tampa ou acessório<select data-nc-v21-accessory>', accessory.html, '</select></label>',
        '<label class="nc-v21-accessory-qty" data-nc-v21-accessory-qty-wrap hidden>Quantidade do acessório<input type="number" data-nc-v21-accessory-qty min="100" step="100" value="1000"></label>',
        '<div class="nc-v21-art__product-total" data-nc-v21-art-total></div>',
        '</div>',
      ].join('');
    }
    return [
      '<div class="nc-v21-builder__head"><div><h3>Monte seu pedido</h3><p>Preço calculado diretamente pela ', priceBookName(reg), '. Mínimo de 1.000 unidades por arte.</p></div>',
      '<label class="nc-v21-builder__arts">Número de artes<select data-nc-v21-arts><option value="1">1 arte</option><option value="2">2 artes</option><option value="3">3 artes</option><option value="4">4 artes</option><option value="5">5 artes</option></select></label></div>',
      '<div data-nc-v21-art-list>', rows, '</div>',
      accessory.count ? '' : '<p class="nc-v21-accessory-note">Tampas e acessórios desta referência serão confirmados pelo atendimento; nenhum preço foi inferido.</p>',
      '<div class="nc-v21-builder__summary">',
      '<div class="nc-v21-summary-card"><span>Unidades</span><strong data-nc-v21-summary-units>0</strong></div>',
      '<div class="nc-v21-summary-card"><span>Acessórios</span><strong data-nc-v21-summary-accessories>0</strong></div>',
      '<div class="nc-v21-summary-card"><span>6x sem juros</span><strong data-nc-v21-summary-installment>R$ 0,00</strong></div>',
      '<div class="nc-v21-summary-card is-primary"><span>Total estimado</span><strong data-nc-v21-summary-total>R$ 0,00</strong></div>',
      '</div>',
      '<div class="nc-v21-shipping" data-nc-v21-shipping></div>',
      '<div class="nc-v21-builder__summary">',
      '<div class="nc-v21-summary-card"><span>Pix à vista · 3% off</span><strong data-nc-v21-summary-pix>R$ 0,00</strong></div>',
      '</div>',
      '<div class="nc-v21-builder__actions"><a class="nc-v21-builder__wa" data-nc-v21-wa target="_blank" rel="noopener">Solicitar orçamento no WhatsApp</a><span class="nc-v21-builder__note">Para entrega em Goiás, finalize seu orçamento com nosso atendimento.</span></div>',
    ].join('');
  }

  function selectedOption(select) {
    return select && select.options ? select.options[select.selectedIndex] : null;
  }

  function normalizeAccessoryQuantity(input, option) {
    var minimum = Math.max(1, Number(option && option.getAttribute('data-minimum')) || 1000);
    var step = Math.max(1, Number(option && option.getAttribute('data-step')) || 1000);
    var value = Math.max(minimum, Number(input && input.value) || minimum);
    value = Math.ceil(value / step) * step;
    if (input) {
      input.min = String(minimum);
      input.step = String(step);
      input.value = String(value);
    }
    return value;
  }

  function updateBuilder(builder, product, resolution, reg) {
    if (!resolution.safe || !resolution.row) return;
    var artCount = Number(builder.querySelector('[data-nc-v21-arts]').value || 1);
    var artNodes = Array.prototype.slice.call(builder.querySelectorAll('[data-nc-v21-art]'));
    var totalCents = 0;
    var totalUnits = 0;
    var totalAccessories = 0;
    var messageLines = [];

    artNodes.forEach(function (art, index) {
      var active = index < artCount;
      art.hidden = !active;
      if (!active) return;
      var quantitySelect = art.querySelector('[data-nc-v21-quantity]');
      var productQuantity = Number(quantitySelect.value || 1000);
      var productPrice = CORE.priceFor(resolution.row, reg, productQuantity);
      if (!productPrice) {
        art.querySelector('[data-nc-v21-art-total]').textContent = 'Consultar';
        return;
      }
      var accessorySelect = art.querySelector('[data-nc-v21-accessory]');
      var accessoryOption = selectedOption(accessorySelect);
      var accessoryRowId = accessorySelect.value || '';
      var accessoryWrap = art.querySelector('[data-nc-v21-accessory-qty-wrap]');
      var accessoryInput = art.querySelector('[data-nc-v21-accessory-qty]');
      var accessoryTotal = 0;
      var accessoryText = '';

      if (accessoryRowId) {
        accessoryWrap.hidden = false;
        if (!accessoryInput.value) accessoryInput.value = String(productQuantity);
        var accessoryQuantity = normalizeAccessoryQuantity(accessoryInput, accessoryOption);
        var accessoryRow = DATA.rowsById[accessoryRowId];
        var accessoryPrice = CORE.priceFor(accessoryRow, reg, accessoryQuantity);
        if (accessoryPrice) {
          accessoryTotal = accessoryPrice.totalCents;
          totalAccessories += accessoryQuantity;
          accessoryText = ' + ' + quantity(accessoryQuantity) + ' ' + accessoryOption.textContent.trim() + ' (' + money(accessoryTotal) + ')';
        }
      } else {
        accessoryWrap.hidden = true;
      }

      totalUnits += productQuantity;
      totalCents += productPrice.totalCents + accessoryTotal;
      art.querySelector('[data-nc-v21-art-total]').textContent = money(productPrice.totalCents + accessoryTotal);
      messageLines.push('Arte ' + (index + 1) + ': ' + quantity(productQuantity) + ' un. ' + money(productPrice.totalCents) + accessoryText);
    });

    builder.querySelector('[data-nc-v21-summary-units]').textContent = quantity(totalUnits);
    builder.querySelector('[data-nc-v21-summary-accessories]').textContent = quantity(totalAccessories);
    builder.querySelector('[data-nc-v21-summary-total]').textContent = money(totalCents);
    builder.querySelector('[data-nc-v21-summary-installment]').textContent = money(Math.round(totalCents / 6));
    builder.querySelector('[data-nc-v21-summary-pix]').textContent = money(Math.round(totalCents * 0.97));

    var shipping = builder.querySelector('[data-nc-v21-shipping]');
    var free = CORE.qualifiesFreeShipping(DATA, reg, totalCents);
    var missing = CORE.amountUntilFreeShipping(DATA, reg, totalCents);
    shipping.classList.toggle('is-free', free);
    if (free) {
      shipping.innerHTML = '<strong>Frete grátis confirmado.</strong> O total atende à condição de ' + priceBookName(reg) + '.';
    } else {
      shipping.innerHTML = '<strong>Frete grátis ainda não atingido.</strong> Acrescente ' + money(missing) + ' ao pedido para alcançar a condição da ' + priceBookName(reg) + '.';
    }

    var whatsapp = builder.querySelector('[data-nc-v21-wa]');
    var text = [
      'Olá! Tenho interesse em ' + product.title + '.',
      'Região: ' + (reg === 'GO' ? 'Goiás' : 'Demais regiões') + '.',
      messageLines.join(' ; ') + '.',
      'Total estimado: ' + money(totalCents) + '.',
      'Pix com 3%: ' + money(Math.round(totalCents * 0.97)) + '.',
      'Pode conferir e gerar meu orçamento?',
    ].join(' ');
    whatsapp.href = 'https://wa.me/5564999480738?text=' + encodeURIComponent(text);
    builder.setAttribute('data-nc-v21-row', resolution.row.id);
    builder.setAttribute('data-nc-v21-region', reg);
  }

  function bindBuilder(builder, product, resolution) {
    if (builder.getAttribute('data-nc-v21-bound') === 'true') return;
    builder.setAttribute('data-nc-v21-bound', 'true');
    builder.addEventListener('change', function (event) {
      var target = event.target;
      if (target && target.matches('[data-nc-v21-accessory]')) {
        var art = target.closest('[data-nc-v21-art]');
        var wrap = art.querySelector('[data-nc-v21-accessory-qty-wrap]');
        var input = art.querySelector('[data-nc-v21-accessory-qty]');
        wrap.hidden = !target.value;
        if (target.value && !input.value) input.value = art.querySelector('[data-nc-v21-quantity]').value;
      }
      updateBuilder(builder, product, resolution, region());
    });
    builder.addEventListener('input', function (event) {
      if (event.target && event.target.matches('[data-nc-v21-accessory-qty]')) {
        updateBuilder(builder, product, resolution, region());
      }
    });
  }

  function renderBuilder(main, product, resolution, reg) {
    var legacy = main.querySelector('.natc-sim-box');
    var existing = main.querySelector('.nc-v21-builder');
    if (!resolution.safe || !resolution.row) {
      legacyVisible(legacy);
      removeNode(existing);
      return;
    }
    legacyHidden(legacy);
    if (!existing) {
      existing = document.createElement('section');
      existing.className = 'nc-v21-builder';
      existing.innerHTML = builderMarkup(product, reg);
      if (legacy) legacy.insertAdjacentElement('afterend', existing);
      else main.appendChild(existing);
      bindBuilder(existing, product, resolution);
    } else {
      var intro = existing.querySelector('.nc-v21-builder__head p');
      if (intro) intro.textContent = 'Preço calculado diretamente pela ' + priceBookName(reg) + '. Mínimo de 1.000 unidades por arte.';
    }
    updateBuilder(existing, product, resolution, reg);
  }

  function renderProduct(main) {
    var product = parseProduct(main);
    if (!product) return;
    var resolution = resolveProduct(product);
    var reg = region();
    if (renderMainPrice(main, product, resolution, reg)) {
      renderPriceTable(main, resolution, reg);
      renderBuilder(main, product, resolution, reg);
      diagnostics.productSafe += 1;
    } else {
      (resolution.reason === 'SOURCE_BLOCKED' ? legacyHidden : legacyVisible)(main.querySelector('.natc-price-box'));
      legacyHidden(main.querySelector('.natc-sim-box'));
      removeAll(main, '.nc-v21-table,.nc-v21-builder');
      diagnostics.productReview += 1;
    }
  }



  function cartLinePricing(line) {
    var dataset = line.dataset || {};
    return CORE.normalizeProductPricing({
      active: true,
      idProduct: dataset.ngiV21Sku || '',
      p1000: line.getAttribute('data-ngi-v21-price-1000') || dataset.ngiV21Price1000 || '',
      p2000: line.getAttribute('data-ngi-v21-price-2000') || dataset.ngiV21Price2000 || '',
      p5000: line.getAttribute('data-ngi-v21-price-5000') || dataset.ngiV21Price5000 || '',
      p10000: line.getAttribute('data-ngi-v21-price-10000') || dataset.ngiV21Price10000 || '',
    });
  }

  function cartLineHandle(line) {
    var dataset = line.dataset || {};
    if (dataset.ngiV21Handle) return String(dataset.ngiV21Handle);
    var link = line.querySelector('a[href*="/products/"]');
    if (!link) return '';
    var href = String(link.getAttribute('href') || '');
    var match = href.match(/\/products\/([^?#/]+)/i);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function remoteProductFromHtml(html, handle) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(String(html || ''), 'text/html');
    var script = doc.querySelector('.data-json-product');
    if (!script) throw new Error('PRODUCT_JSON_NOT_FOUND:' + handle);
    var json = JSON.parse(script.textContent || '{}');
    var pricing = json.pricing || {};
    var variants = Array.isArray(json.variants) ? json.variants : [];
    var variant = variants[0] || {};
    return {
      handle: String(json.handle || handle || ''),
      title: String(json.title || ''),
      pricing: CORE.normalizeProductPricing({
        active: pricing.active !== undefined ? pricing.active : pricing.ativo,
        idProduct: pricing.idProduct || pricing.id_produto || variant.sku || '',
        p1000: pricing.p1000 !== undefined ? pricing.p1000 : pricing.preco_1000,
        p2000: pricing.p2000 !== undefined ? pricing.p2000 : pricing.preco_2000,
        p5000: pricing.p5000 !== undefined ? pricing.p5000 : pricing.preco_5000,
        p10000: pricing.p10000 !== undefined ? pricing.p10000 : pricing.preco_10000,
      }),
    };
  }

  function loadCartProduct(handle) {
    var key = String(handle || '').trim();
    if (!key) return Promise.reject(new Error('CART_HANDLE_MISSING'));
    if (!cartProductCache[key]) {
      cartProductCache[key] = fetch('/products/' + encodeURIComponent(key) + '?ngi_v21_cart=1', {
        method: 'GET', credentials: 'same-origin', headers: { Accept: 'text/html' },
      }).then(function (response) {
        if (!response.ok) throw new Error('PRODUCT_FETCH_' + response.status + ':' + key);
        return response.text();
      }).then(function (html) { return remoteProductFromHtml(html, key); });
    }
    return cartProductCache[key];
  }

  function hydrateCartLine(line) {
    var pricing = cartLinePricing(line);
    if (CORE.completeProductSignature(pricing)) return Promise.resolve(true);
    var handle = cartLineHandle(line);
    if (!handle) return Promise.resolve(false);
    var request = line.getAttribute('data-nc-v21-cart-hydrating');
    if (request === handle) return Promise.resolve(false);
    line.setAttribute('data-nc-v21-cart-hydrating', handle);
    return loadCartProduct(handle).then(function (product) {
      if (!line.isConnected) return false;
      line.dataset.ngiV21Handle = product.handle;
      line.dataset.ngiV21Sku = product.pricing.sku || '';
      line.dataset.ngiV21Price1000 = product.pricing.tiers['1000'] ? (product.pricing.tiers['1000'] / 100).toFixed(2) : '';
      line.dataset.ngiV21Price2000 = product.pricing.tiers['2000'] ? (product.pricing.tiers['2000'] / 100).toFixed(2) : '';
      line.dataset.ngiV21Price5000 = product.pricing.tiers['5000'] ? (product.pricing.tiers['5000'] / 100).toFixed(2) : '';
      line.dataset.ngiV21Price10000 = product.pricing.tiers['10000'] ? (product.pricing.tiers['10000'] / 100).toFixed(2) : '';
      line.removeAttribute('data-nc-v21-cart-hydrating');
      scheduleScan();
      return true;
    }).catch(function (error) {
      line.removeAttribute('data-nc-v21-cart-hydrating');
      diagnostics.errors.push('CART_PRODUCT_LOAD_FAILED:' + handle);
      console.error('[Natucopos V2.1] Falha ao carregar identidade do item do carrinho.', error);
      return false;
    });
  }

  function cartQuoteHost(line) {
    return line.querySelector('.wrap_title_cart,.mini_cart_meta,.mini_cart_body,.info,.product-name') || line;
  }

  function cartLegacyPrices(line) {
    var nodes = Array.prototype.slice.call(line.querySelectorAll('.cart_meta_price,.cart_meta_prices,.js_tt_price_it'));
    var compact = line.querySelector('.product-item-qty .number.price > span:not(.qty)');
    if (compact) nodes.push(compact);
    return nodes;
  }

  function cartLineNodes() {
    return document.querySelectorAll('[data-ngi-v21-cart-line],.natucopos-cart-form tr.product-item,.mini_cart_item.js_cart_item,.cart_item.js_cart_item,.mini_cart .product-item,.mini_cart_wrap .product-item');
  }

  function clearCartQuote(line) {
    line.removeAttribute('data-nc-v21-cart-resolved');
    line.removeAttribute('data-nc-v21-cart-total-cents');
    line.removeAttribute('data-nc-v21-cart-commercial-quantity');
    var existing = line.querySelector('.nc-v21-cart-line-quote');
    removeNode(existing);
    cartLegacyPrices(line).forEach(legacyVisible);
  }

  function cartCommercialQuantity(line) {
    var dataset = line.dataset || {};
    var raw = Number(dataset.ngiV21CartQuantity || 0);
    var input = line.querySelector('input.qty,input[name="updates[]"],[data-quantity-input]');
    if (input && Number(input.value) > 0) raw = Number(input.value);
    if (!Number.isFinite(raw) || raw <= 0) raw = 1;
    return raw >= 1000 ? Math.round(raw) : Math.round(raw * 1000);
  }

  function cartLineKey(line, resolution) {
    var dataset = line.dataset || {};
    return String(dataset.ngiV21LineKey || dataset.ngiV21Handle || (resolution && resolution.rowId) || '').trim();
  }

  function renderCartSummary(reg, quoteByKey) {
    Array.prototype.slice.call(document.querySelectorAll('.nc-v21-cart-summary')).forEach(removeNode);
    var keys = Object.keys(quoteByKey || {});
    if (!keys.length) return;
    var totalCents = keys.reduce(function (sum, key) { return sum + Number(quoteByKey[key].totalCents || 0); }, 0);
    var totalUnits = keys.reduce(function (sum, key) { return sum + Number(quoteByKey[key].quantity || 0); }, 0);
    var free = CORE.qualifiesFreeShipping(DATA, reg, totalCents);
    var missing = CORE.amountUntilFreeShipping(DATA, reg, totalCents);
    var summary = document.createElement('div');
    summary.className = 'nc-v21-cart-summary';
    summary.setAttribute('data-nc-v21-region', reg);
    summary.setAttribute('data-nc-v21-total-cents', String(totalCents));
    summary.innerHTML = [
      '<strong>' + (diagnostics.cartReview ? 'Subtotal dos itens conferidos — ' : 'Total estimado — ') + priceBookName(reg) + ': ' + money(totalCents) + '</strong>',
      '<span>' + quantity(totalUnits) + ' unidades em ' + keys.length + ' item(ns) com preço conferido.' + (diagnostics.cartReview ? ' Outros itens precisam de orçamento e não estão incluídos neste subtotal.' : '') + '</span>',
      '<small>' + commercialTerms(reg) + '</small>',
      '<em>' + (free ? 'Frete grátis atingido para esta região.' : 'Faltam ' + money(missing) + ' para a condição de frete grátis.') + '</em>',
      '<small>Orçamento estimado. Confirme os valores finais com o atendimento antes do pagamento.</small>',
    ].join('');
    var target = document.querySelector('.natucopos-order-summary,.cms-bottom-group,.cart__footer,.cart-footer,.box-bottom-btn,.main-cart-footer');
    if (target) target.insertAdjacentElement('afterbegin', summary);
  }

  function renderCartQuotes(reg) {
    var lines = Array.prototype.slice.call(cartLineNodes());
    var quoteByKey = Object.create(null);
    diagnostics.cartSafe = 0;
    diagnostics.cartReview = 0;
    Array.prototype.slice.call(document.querySelectorAll('.nc-v21-cart-summary')).forEach(removeNode);
    lines.forEach(function (line) {
      var pricing = cartLinePricing(line);
      if (!CORE.completeProductSignature(pricing)) {
        hydrateCartLine(line);
        clearCartQuote(line);
        diagnostics.cartReview += 1;
        return;
      }
      var resolution = CORE.resolveProduct(DATA, pricing);
      var existing = line.querySelector('.nc-v21-cart-line-quote');
      if (!resolution.safe || !resolution.row) {
        clearCartQuote(line);
        consultMessage(line, resolution.reason);
        diagnostics.cartReview += 1;
        return;
      }
      var commercialQuantity = cartCommercialQuantity(line);
      var quote = CORE.priceFor(resolution.row, reg, commercialQuantity);
      if (!quote) {
        clearCartQuote(line);
        diagnostics.cartReview += 1;
        return;
      }
      if (!existing) {
        existing = document.createElement('div');
        existing.className = 'nc-v21-cart-line-quote';
        cartQuoteHost(line).appendChild(existing);
      }
      existing.innerHTML = '<strong>' + priceBookName(reg) + ': ' + money(quote.totalCents) + '</strong><span>' + quantity(commercialQuantity) + ' unidades · ' + money(quote.perThousandCents) + ' por milheiro</span><small>' + commercialTerms(reg) + '</small>';
      existing.setAttribute('data-nc-v21-row', resolution.row.id);
      existing.setAttribute('data-nc-v21-region', reg);
      line.setAttribute('data-nc-v21-cart-resolved', 'true');
      line.setAttribute('data-nc-v21-cart-total-cents', String(quote.totalCents));
      line.setAttribute('data-nc-v21-cart-commercial-quantity', String(commercialQuantity));
      cartLegacyPrices(line).forEach(legacyHidden);
      var key = cartLineKey(line, resolution);
      if (key && !quoteByKey[key]) quoteByKey[key] = quote;
      diagnostics.cartSafe += 1;
    });
    renderCartSummary(reg, quoteByKey);
  }

  function checkoutControls() {
    return document.querySelectorAll('a[href*="/checkout"],button[name="checkout"],input[name="checkout"],.shopify-payment-button__button');
  }

  function renderCartGate(reg) {
    Array.prototype.slice.call(checkoutControls()).forEach(function (control) {
      control.setAttribute('data-nc-v21-checkout-disabled', 'true');
      control.setAttribute('aria-disabled', 'true');
      control.classList.add('nc-v21-legacy-hidden');
    });
    var existing = document.querySelector('.nc-v21-cart-warning');
    if (existing) existing.remove();
    diagnostics.checkoutBlocked = true;
  }

  function updateBadge() {
    var badge = document.querySelector('.nc-v21-qa-badge');
    if (!badge) {
      badge = document.createElement('div');
      badge.className = 'nc-v21-qa-badge';
      document.body.appendChild(badge);
    }
    badge.textContent = 'V2.1 CLEAN · ' + region() + ' · ' + diagnostics.cardsSafe + ' cards · ' + diagnostics.productSafe + ' produto · ' + diagnostics.cartSafe + ' carrinho';
  }

  function failClosed(errors) {
    diagnostics.errors = diagnostics.errors.concat(errors || ['UNKNOWN_FAILURE']);
    root.classList.add('nc-v21-failed');
    root.classList.remove('nc-v21-ready');
    var badge = document.querySelector('.nc-v21-qa-badge');
    if (!badge) {
      badge = document.createElement('div');
      badge.className = 'nc-v21-qa-badge is-error';
      document.body.appendChild(badge);
    }
    badge.classList.add('is-error');
    badge.textContent = 'V2.1 BLOQUEADA · Tabela Brasil preservada';
    console.error('[Natucopos V2.1] Integridade falhou.', errors);
  }

  function scan() {
    Array.prototype.slice.call(document.querySelectorAll('.content p')).forEach(function (node) {
      if (!node.hasAttribute('data-nc-v21-shipping-copy') && /^Em compras a partir de R\$\s*2[.,]?000\s*$/.test(node.textContent.trim())) node.setAttribute('data-nc-v21-shipping-copy', 'true');
      if (node.hasAttribute('data-nc-v21-shipping-copy')) {
        var shippingCopy = region() === 'GO' ? 'Em compras a partir de R$ 500 para entrega em Goiás' : 'Em compras a partir de R$ 2.000';
        if (node.textContent !== shippingCopy) node.textContent = shippingCopy;
      }
    });
    diagnostics.scans += 1;
    diagnostics.cardsSafe = 0;
    diagnostics.cardsReview = 0;
    diagnostics.productSafe = 0;
    diagnostics.productReview = 0;
    Array.prototype.slice.call(document.querySelectorAll('.product-collection')).forEach(function (node) {
      try { renderCard(node); }
      catch (error) { diagnostics.cardsReview += 1; diagnostics.errors.push('CARD_RENDER_FAILED'); console.error('[Natucopos V2.1] Falha isolada no card.', error); }
    });
    Array.prototype.slice.call(document.querySelectorAll('.main-product')).forEach(function (node) {
      try { renderProduct(node); }
      catch (error) { diagnostics.productReview += 1; diagnostics.errors.push('PRODUCT_RENDER_FAILED'); console.error('[Natucopos V2.1] Falha isolada no produto.', error); }
    });
    try { renderCartQuotes(region()); }
    catch (error) { diagnostics.errors.push('CART_RENDER_FAILED'); console.error('[Natucopos V2.1] Falha isolada no carrinho.', error); }
    renderCartGate(region());
    syncRegionControl();
    root.classList.add('nc-v21-ready');
    root.classList.remove('nc-v21-failed');
    root.classList.remove('nc-v21-go-pending');
    updateBadge();
  }

  function scheduleScan() {
    if (scheduled) return;
    scheduled = true;
    Promise.resolve().then(function () {
      scheduled = false;
      scan();
    });
  }

  function addedNodeRelevant(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches && node.matches('.product-collection,.main-product,.nc-card-commerce-pod,.mini_cart,.cart,.cart__footer,.main-cart-footer,[data-ngi-v21-cart-line],.mini_cart_item,.cart_item,.natucopos-cart-form')) return true;
    return !!(node.querySelector && node.querySelector('.product-collection,.main-product,.nc-card-commerce-pod,.mini_cart,.cart,.cart__footer,.main-cart-footer,[data-ngi-v21-cart-line],.mini_cart_item,.cart_item,.natucopos-cart-form'));
  }

  function start() {
    initRegionUi();
    diagnostics.integrity = CORE && DATA ? CORE.validateData(DATA) : { ok: false, errors: ['CORE_OR_DATA_MISSING'] };
    if (!diagnostics.integrity.ok) {
      failClosed(diagnostics.integrity.errors);
      return;
    }
    scan();
    observer = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes || [], addedNodeRelevant);
      });
      if (relevant) scheduleScan();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    diagnostics.observerCount = 1;
  }

  document.addEventListener('natucopos:regionchange', function () {
    syncRegionControl();
    scheduleScan();
  });
  document.addEventListener('natucopos:open-region', function () { openRegionModal(true); });
  document.addEventListener('change', function (event) {
    if (event.target && event.target.closest && event.target.closest('[data-ngi-v21-cart-line],.mini_cart_item,.cart_item,.natucopos-cart-form tr.product-item')) scheduleScan();
  });
  document.addEventListener('input', function (event) {
    if (event.target && event.target.closest && event.target.closest('[data-ngi-v21-cart-line],.mini_cart_item,.cart_item,.natucopos-cart-form tr.product-item')) scheduleScan();
  });

  document.addEventListener('click', function (event) {
    var blocked = event.target && event.target.closest && event.target.closest('[data-nc-v21-checkout-disabled="true"]');
    if (blocked) {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign('/cart');
      return false;
    }
    return true;
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();

  window.NatucoposPricingV21 = {
    version: '2.1.0-clean-qa',
    data: DATA,
    core: CORE,
    scan: scan,
    resolve: function (pricing) { return CORE.resolveProduct(DATA, pricing); },
    openRegionSelector: function () { openRegionModal(true); },
    region: function () { return regionState(); },
    diagnostics: diagnostics,
  };
})(window, document);
// Desenvolvido por Clan Digital - https://clanmarketing.com.br/
